<template>
  <v-container style="background-color: white;min-height: 700px" class="rounded-lg gradient">
    <v-row>
      <v-col cols="12" md="2">
        <v-banner color="purple" dark shaped height="50px" width="300px">
          <h2>KEYNOTE SPEAKERS</h2>
        </v-banner>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="12" md="3">
        <profile
            name="Prof. Raymond Yeung"
            org="The Chinese University of Hong Kong"
            pos=""
            :photo="require('../assets/Committees/speakers/Yeung.jpg')"
        ></profile>
      </v-col>
      <v-col md="7" class="overflow-y-auto rounded-lg" style="max-height: 500px; background-color: #00000015">
        <p>
          Raymond W. Yeung is the Choh-Ming Li Professor of Information Engineering at The Chinese University of Hong
          Kong (CUHK). He received his B.S., M.Eng., and PhD degrees from Cornell University in Electrical Engineering
          in 1984, 1985, and 1988, respectively. Before joining CUHK in 1991, he was a Member of Technical Staff at AT&T
          Bell Laboratories. A co-founder of the field of network coding, he has been serving as Co-Director of the
          Institute of Network Coding at CUHK since 2010. He is the author of the books A First Course in Information
          Theory (Kluwer Academic/Plenum Publishers, 2002) and Information Theory and Network Coding (Springer 2008),
          which have been adopted by over 100 institutions around the world. In spring 2014, he gave the first MOOC in
          the world on information theory that reached over 25,000 students.
        </p>
        <p>
          He is a recipient of the 2005 IEEE Information Theory Society Paper Award, the Friedrich Wilhelm Bessel
          Research Award from the Alexander von Humboldt Foundation in 2007, the 2016 IEEE Eric E. Sumner Award, the
          2018 ACM SIGMOBILE Test-of-Time Paper Award, the 2021 IEEE Richard W. Hamming Medal, and the 2022 Claude E.
          Shannon Award. In 2015, he was named an Outstanding Overseas Chinese Information Theorist by the China
          Information Theory Society. He is a Fellow of the IEEE, Hong Kong Academy of Engineering Sciences, and Hong
          Kong Institution of Engineers.
        </p>
      </v-col>
    </v-row>
    <br>
    <v-divider></v-divider>
    <br>
    <v-row justify="center" align="center">
      <v-col cols="12" md="3">
        <profile
            name="Prof. Vincent Lau"
            org="The Hong Kong University of Science and Technology"
            pos=""
            :photo="require('../assets/Committees/speakers/Lau.jpg')"
        ></profile>
      </v-col>
      <v-col md="7" class="overflow-y-auto rounded-lg" style="max-height: 500px; background-color: #00000015">
        <p>
          Vincent obtained B.Eng (Distinction 1st Hons) from the University of Hong Kong (1989-1992) and Ph.D. from the
          Cambridge University (1995-1997). He joined Bell Labs from 1997-2004 and the Department of ECE, Hong Kong
          University of Science and Technology (HKUST) in 2004. He is currently a Chair Professor and the Founding
          Director of Huawei-HKUST Joint Innovation Lab at HKUST. He is also elected as IEEE Fellow, HKIE Fellow,
          Croucher Senior Research Fellow and Changjiang Chair Professor. Vincent has published more than 400 IEEE
          journal and conference papers and has contributed to 50 US patents on various wireless systems as well as 4
          IEEE standard contributions. His current research focus includes Stochastic Optimization and Analysis for
          wireless systems, Massive MIMO Systems, Sparse Recovery, Bayesian Inferencing, Mission-Critical IoT as well as
          PHY Caching for Wireless Networks.
        </p>
      </v-col>
    </v-row>
    <br>
    <v-divider></v-divider>
    <br>
    <v-row justify="center" align="center">
      <v-col md="3">
        <profile
            name="Prof. Zhu Han"
            org="University of Houston"
            pos=""
            :photo="require('../assets/Committees/speakers/Han.jpg')"
        ></profile>
      </v-col>
      <v-col md="7" class="overflow-y-auto rounded-lg" style="max-height: 500px; background-color: #00000015">
        <p>
          Zhu Han received the B.S. degree in electronic engineering from Tsinghua University, in 1997, and the M.S. and
          Ph.D. degrees in electrical engineering from the University of Maryland, College Park, in 1999 and 2003,
          respectively. From 2000 to 2002, he was an R&D Engineer of JDSU, Germantown, Maryland. From 2003 to 2006, he
          was a Research Associate at the University of Maryland. From 2006 to 2008, he was an assistant professor in
          Boise State University, Idaho. Currently, he is a John and Rebecca Moores Professor in Electrical and Computer
          Engineering Department as well as Computer Science Department at University of Houston, Texas. His research
          interests include security, wireless resource allocation and management, wireless communication and
          networking, game theory, and wireless multimedia. Dr. Han is an NSF CAREER award recipient 2010. Dr. Han has
          several IEEE conference best paper awards, and winner of 2011 IEEE Fred W. Ellersick Prize, 2015 EURASIP Best
          Paper Award for the Journal on Advances in Signal Processing and 2016 IEEE Leonard G. Abraham Prize in the
          field of Communication Systems (Best Paper Award for IEEE Journal on Selected Areas on Communications). Dr.
          Han is the winner 2021 IEEE Kiyo Tomiyasu Award. He has been IEEE fellow since 2014, AAAS fellow since 2020
          and IEEE Distinguished Lecturer from 2015 to 2018. Dr. Han is 1% highly cited researcher according to Web of
          Science since 2017.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Profile from "@/components/Committees/Profile";

export default {
  name: "Speakers",
  components: {Profile}
}
</script>

<style scoped>
img {
  background: rgb(143, 131, 120);
  object-fit: cover;
  width: 200px;
  height: 250px;
}
</style>
